import React, { useState } from "react";
import { convertToRaw } from "draft-js";
import { stateToHTML } from "draft-js-export-html";
import * as commondata from "../../Common";

const TextAreaCompo = ({ text }) => {
  const [state, setState] = useState({ isExpanded: false });
  const convertToRawContent = (raw) => {
    const { blocks, entityMap } = raw;
    let content = "";
    Object.keys(blocks).map((i) => {
      const { entityRanges, text } = blocks[i];
      const textLength = text.length;

      let startRange = 0;
      entityRanges.map((range) => {
        content += text.substr(startRange, range.offset - startRange);
        content += '<a href="">';
        content += text.substr(range.offset, range.length);
        content += "</a>";
        startRange = range.offset + range.length;
      });
      content += text.substr(startRange, textLength);
      content += "\r\n";
    });

    return content;
  };

  const toggleExpandHandler = () => {
    setState((state) => {
      return { ...state, isExpanded: !state.isExpanded };
    });
  };

  let newstate = commondata.IsJsonString(text) ? JSON.parse(text) : "";
  if (newstate) {
    text = convertToRawContent(newstate);
  }
  if (state.isExpanded) {
    return (
      <>
        <div className="text" dangerouslySetInnerHTML={{ __html: text }}></div>
        <div class="showLess" onClick={toggleExpandHandler}>
          {state.isExpanded ? "Show Less" : "Show More"}
        </div>
      </>
    );
  } else {
    if (text?.length > 150) {
      return (
        <>
          <div
            className="text"
            dangerouslySetInnerHTML={{ __html: text.slice(0, 150) + "..." }}
          ></div>{" "}
          <div class="showLess" onClick={toggleExpandHandler}>
            {state.isExpanded ? "Show Less" : "Show More"}
          </div>
        </>
      );
    } else {
      return (
        <>
          <div
            className="text"
            dangerouslySetInnerHTML={{ __html: text }}
          ></div>{" "}
        </>
      );
    }
  }
};

export default TextAreaCompo;
